<template>
    <v-input :rules="field.rules" :value="value">
        <v-file-input
            v-show="false"
            :ref="'file' + [field.key]"
            :prepend-icon="null"
            :accept="field.accept"
            append-icon="mdi-camera"
            @change="(value) => selectFile(value)"
            outlined
        ></v-file-input>
        <div>
            <v-img
                @click="uploadFile(field)"
                :src="previewUrl(value)"
                height="180px"
                width="fit-content"
                :loading="true"
                contain
                position="left"
            >
                <v-btn width="300px" height="180px" v-if="!value">
                    <v-icon>mdi-upload</v-icon>
                    upload
                </v-btn>
            </v-img>
            <div>
                <v-btn v-if="value" class="close" @click="clear" color="primary" small>移除</v-btn>
                <template v-else>{{ field.hint }}</template>
            </div>
        </div>
    </v-input>
</template>

<script>

export default {
    props: {
        value: String,
        field: Object,
    },
    computed: {
        previewUrl() {
            return (value) => {
                if (value && value.startsWith('blob:')) return value;
                return process.env.VUE_APP_BASE_URL + value;
            };
        },
    },
    methods: {
        clear() {
            this.$emit('input', null);
        },
        uploadFile(field) {
            const fileInput = this.$refs[`file${field.key}`];
            if (fileInput) fileInput.$el.getElementsByTagName('input')[0].click();
        },
        selectFile(file) {
            if (file) {
                // TODO: 壓縮圖片, 壓縮比率資訊: field.compress
                this.$emit('input', URL.createObjectURL(file));
            }
        },
    },
};
</script>

<style>
</style>
